angular.module('gym.components').directive('subscriptionInvoices', function() {
  return {
    restrict: 'E',
    template: require('templates/components/subscriptions/subscription_invoices.html.slim'),
    scope: {
      gym: '='
    },
    controller: ["$scope", "$stateParams", "$http", "ngTableParams", function($scope, $stateParams, $http, ngTableParams) {
      $scope.pageParams = {};
      $scope.gymId = $stateParams.gymId;
      $scope.invoiceStatus = function(invoice) {
        switch (false) {
          case !invoice.succeeded:
            return 'Paid';
          case !invoice.pending:
            return 'Pending';
          case !invoice.failed:
            return 'Failed';
        }
      };
      return $scope.tableParams = new ngTableParams({
        page: 1,
        count: 15
      }, {
        counts: [],
        total: 0,
        getData: function($defer, $params) {
          var url;
          url = `/gyms/${$stateParams.gymId}/gym_invoices`;
          $scope.pageParams.isLoading = true;
          return $http.get(url, {
            params: $params.url()
          }).then(function(response) {
            $scope.pageParams.isLoading = false;
            $scope.pageParams.total = response.data.total;
            $params.total(response.data.total);
            return $defer.resolve(response.data.collection);
          }, function() {
            return $scope.pageParams.isLoading = false;
          });
        }
      });
    }]
  };
});
